import { Navigate, useRoutes } from 'react-router-dom';


import OrderDetailsPage from 'src/pages/dashboard/orders/OrderDetailsPage';
import AgentLayout from '../layouts/agent_view/AgentView';
import AgentOrdersListPage from '../pages/agent/AgentOrdersListPage';
import AgentOrderDetailPage from '../pages/agent/AgentOrderDetailPage';
import VoiceAgentDashboardPage from '../pages/voice-agent/VoiceAgentDashboardPage';
import VoiceAgentOrderTakingPage from '../pages/voice-agent/VoiceAgentOrderTakingPage';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
import RoleBasedGuard from '../auth/RoleBasedGuard';
// layouts
import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,
  // Dashboard: General
  GeneralAppPage,
  GeneralFilePage,
  GeneralBankingPage,
  GeneralBookingPage,
  GeneralEcommercePage,
  GeneralAnalyticsPage,
  UserCardsPage,
  UserAccountPage,
  // Dashboard: Ecommerce
  EcommerceShopPage,
  EcommerceCheckoutPage,
  EcommerceProductListPage,
  EcommerceProductEditPage,
  EcommerceProductCreatePage,
  EcommerceProductDetailsPage,
  // Dashboard: Invoice
  InvoiceListPage,
  InvoiceHistoryPage,
  OrdersListPage,
  InvoiceDetailsPage,
  InvoiceCreatePage,
  InvoiceEditPage,

  // Dashboard: Blog
  BlogPostsPage,
  BlogPostPage,
  BlogNewPostPage,
  // Dashboard: FileManager
  FileManagerPage,
  // Dashboard: App
  ChatPage,
  MailPage,
  CalendarPage,
  KanbanPage,
  //
  BlankPage,
  PermissionDeniedPage,
  //
  Page500,
  Page403,
  Page404,
  HomePage,
  FaqsPage,
  AboutPage,
  Contact,
  PricingPage,
  PaymentPage,
  ComingSoonPage,
  MaintenancePage,
  //
  ComponentsOverviewPage,
  FoundationColorsPage,
  FoundationTypographyPage,
  FoundationShadowsPage,
  FoundationGridPage,
  FoundationIconsPage,
  //
  MUIAccordionPage,
  MUIAlertPage,
  MUIAutocompletePage,
  MUIAvatarPage,
  MUIBadgePage,
  MUIBreadcrumbsPage,
  MUIButtonsPage,
  MUICheckboxPage,
  MUIChipPage,
  MUIDataGridPage,
  MUIDialogPage,
  MUIListPage,
  MUIMenuPage,
  MUIPaginationPage,
  MUIPickersPage,
  MUIPopoverPage,
  MUIProgressPage,
  MUIRadioButtonsPage,
  MUIRatingPage,
  MUISliderPage,
  MUIStepperPage,
  MUISwitchPage,
  MUITablePage,
  MUITabsPage,
  MUITextFieldPage,
  MUITimelinePage,
  MUITooltipPage,
  MUITransferListPage,
  MUITreesViewPage,
  //
  DemoAnimatePage,
  DemoCarouselsPage,
  DemoChartsPage,
  DemoCopyToClipboardPage,
  DemoEditorPage,
  DemoFormValidationPage,
  DemoImagePage,
  DemoLabelPage,
  DemoLightboxPage,
  DemoMapPage,
  DemoMegaMenuPage,
  DemoMultiLanguagePage,
  DemoNavigationBarPage,
  DemoOrganizationalChartPage,
  DemoScrollbarPage,
  DemoSnackbarPage,
  DemoTextMaxLinePage,
  DemoUploadPage,
  DemoMarkdownPage, OrgProfilePage, SubOrgProfilePage, OrgsListPage, OrgCreatePage, OrgEditPage,
  ParentOrgInfoPage,
  OrgUserCreatePage, OrgUserEditPage, OrgUserDetailsPage,
  SubOrgCreatePage, SubOrgEditPage, SubOrgDetailsPage,
  SubOrgUserCreatePage, SubOrgUserEditPage, SubOrgUserDetailsPage, SubOrgUsersListPage,
  ProductCreatePage, ProductEditPage, ProductDetailsPage,
  CategoryCreatePage,
  CategoryListPage,
  OrgDetailsPage,
  BranchSettingsPage,
  SubOrgsListPage,
  CompanySettingsPage,
  AllUsersListPage,
  UpsellPage,
  ActionLogsPage,
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralAppPage /> },
        { path: 'analytics', element: <GeneralAnalyticsPage /> },
        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
            { path: 'shop', element: <EcommerceShopPage /> },
            { path: 'product/:name', element: <EcommerceProductDetailsPage /> },
            { path: 'list/:parentOrgId/:subOrgId', element: <EcommerceProductListPage /> },
            { path: 'product/new', element: <EcommerceProductCreatePage /> },
            { path: 'product/:name/edit', element: <EcommerceProductEditPage /> },
            { path: 'checkout', element: <EcommerceCheckoutPage /> },
          ],
        },



        // TODO(NOTE): for the following 4 paths collections I will handle paths in a consistent way later
        // Parent Organization Paths
        {
          path: 'organization',
          children: [
            { element: <Navigate to="/dashboard/organization/list" replace />, index: true },
            { path: 'cards', element: <UserCardsPage /> },
            { path: 'list', element: < OrgsListPage /> },
            { path: 'new', element: <OrgCreatePage /> },
            { path: ':name/edit', element: <OrgEditPage /> },
            { path: ':name/details', element: <OrgDetailsPage /> },
            { path: ':name/branches', element: < OrgProfilePage /> },
            { path: ':parentOrgId/branches/:subOrgId/details', element: < SubOrgProfilePage /> },
            { path: ':parentOrgId/branches/:subOrgId/parent-info', element: <ParentOrgInfoPage /> },
            { path: ':parentOrgId/branches/:subOrgId/settings', element: <BranchSettingsPage /> },
          ],
        },


        // Parent Organization Users Paths
        {
          path: 'parentOrganization-users',
          children: [
            { path: ':name/new', element: <OrgUserCreatePage /> },
            { path: ':organizationId/user/:userId/edit', element: <OrgUserEditPage /> },
            { path: ':organizationId/user/:userId/details', element: <OrgUserDetailsPage /> },
          ],
        },

        // Sub Organization Paths
        {
          path: 'sub-organization',
          children: [
            { element: <Navigate to="/dashboard/sub-organization/list" replace />, index: true },
            { path: 'list', element: <SubOrgsListPage /> },
            { path: ':parentId/new', element: <SubOrgCreatePage /> },
            { path: ':parentId/:subOrgId/edit', element: <SubOrgEditPage /> },
            { path: ':subOrgId/details', element: <SubOrgDetailsPage /> },
          ],
        },

        // Sub Organization Users Paths
        {
          path: 'sub-organization-users',
          children: [
            { path: ':parentOrgId/:subOrgId/list', element: <SubOrgUsersListPage /> },
            { path: ':parentOrgId/:subOrgId/new', element: <SubOrgUserCreatePage /> },
            { path: ':parentOrgId/:subOrgId/user/:userId/edit', element: <SubOrgUserEditPage /> },
            { path: ':parentOrgId/:subOrgId/user/:userId/details', element: <SubOrgUserDetailsPage /> },
          ],
        },


        // Products Paths
        {
          path: 'products',
          children: [
            { path: ':parentOrgId/:subOrgId/list', element: <EcommerceProductListPage /> },
            { path: ':parentOrgId/:subOrgId/new', element: <ProductCreatePage /> },
            { path: ':parentOrgId/:subOrgId/:productId/edit', element: <ProductEditPage /> },
            { path: ':parentOrgId/:subOrgId/:productId/details', element: <ProductDetailsPage /> },
          ],
        },

        // Orders Paths
        {
          path: 'orders',
          children: [
            { path: 'list/:subOrgId', element: <OrdersListPage /> },
            { path: 'all', element: <OrdersListPage /> },
            { path: ':subOrgId/new', element: <ProductCreatePage /> },
            { path: ':orderId/details', element: <OrderDetailsPage /> },
          ],
        },








        // User Paths
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/profile" replace />, index: true },
            { path: 'profile', element: <UserAccountPage /> },
            { path: 'account', element: <UserAccountPage /> },
          ],
        },

        {
          path: 'invoice',
          children: [
            { element: <Navigate to="/dashboard/invoice/list" replace />, index: true },
            { path: 'list', element: <InvoiceHistoryPage /> },
            { path: 'list/:subOrgId', element: <InvoiceHistoryPage /> },
            { path: 'analytics/:subOrgId', element: <InvoiceListPage /> },
            { path: ':id', element: <InvoiceDetailsPage /> },
            { path: ':id/edit', element: <InvoiceEditPage /> },
            { path: 'new', element: <InvoiceCreatePage /> },
          ],
        },
        {
          path: 'users',
          children: [
            { path: 'all', element: <AllUsersListPage /> },
          ],
        },
        {
          path: 'category',
          children: [
            { element: <Navigate to="/dashboard/category/list" replace />, index: true },
            { path: 'list/:subOrgId', element: <CategoryListPage /> },
            { path: 'list', element: <CategoryListPage /> },
            { path: 'new', element: <CategoryCreatePage /> },
            { path: ':id/edit', element: <CategoryCreatePage /> }, // Or CategoryEditPage if it exists and is ready
          ],
        },
        {
          path: 'blog',
          children: [
            { element: <Navigate to="/dashboard/blog/posts" replace />, index: true },
            { path: 'posts', element: <BlogPostsPage /> },
            { path: 'post/:title', element: <BlogPostPage /> },
            { path: 'new', element: <BlogNewPostPage /> },
          ],
        },
        { path: 'files-manager', element: <FileManagerPage /> },
        {
          path: 'mail',
          children: [
            { element: <Navigate to="/dashboard/mail/all" replace />, index: true },
            { path: 'label/:customLabel', element: <MailPage /> },
            { path: 'label/:customLabel/:mailId', element: <MailPage /> },
            { path: ':systemLabel', element: <MailPage /> },
            { path: ':systemLabel/:mailId', element: <MailPage /> },
          ],
        },
        {
          path: 'chat',
          children: [
            { element: <ChatPage />, index: true },
            { path: 'new', element: <ChatPage /> },
            { path: ':conversationKey', element: <ChatPage /> },
          ],
        },
        { path: 'calendar', element: <CalendarPage /> },
        { path: 'kanban', element: <KanbanPage /> },
        {
          path: 'company',
          children: [
            { element: <Navigate to="/dashboard/company/settings/general" replace />, index: true },
            { path: 'settings', element: <Navigate to="/dashboard/company/settings/general" replace /> },
            { path: 'settings/:tab', element: <CompanySettingsPage /> },
          ],
        },
        { 
          path: 'upselling', 
          element: (
            <RoleBasedGuard roles={['MANAGER', '12']}>
              <UpsellPage />
            </RoleBasedGuard>
          ) 
        },
        { path: 'permission-denied', element: <PermissionDeniedPage /> },
        { path: 'blank', element: <BlankPage /> },
        {
          path: 'action-logs',
          element: (
            <RoleBasedGuard roles={['SUPER_ADMIN', 'SUPPORT']}>
              <ActionLogsPage />
            </RoleBasedGuard>
          ),
        },
      ],
    },

    // Main Routes
    {
      element: <MainLayout />,
      children: [
        // { element: <HomePage />, index: true },
        { element: <Navigate to="/auth/login" replace />, index: true },
        { path: 'about-us', element: <AboutPage /> },
        { path: 'contact-us', element: <Contact /> },
        { path: 'faqs', element: <FaqsPage /> },
        // Demo Components
        {
          path: 'components',
          children: [
            { element: <ComponentsOverviewPage />, index: true },
            {
              path: 'foundation',
              children: [
                { element: <Navigate to="/components/foundation/colors" replace />, index: true },
                { path: 'colors', element: <FoundationColorsPage /> },
                { path: 'typography', element: <FoundationTypographyPage /> },
                { path: 'shadows', element: <FoundationShadowsPage /> },
                { path: 'grid', element: <FoundationGridPage /> },
                { path: 'icons', element: <FoundationIconsPage /> },
              ],
            },
            {
              path: 'mui',
              children: [
                { element: <Navigate to="/components/mui/accordion" replace />, index: true },
                { path: 'accordion', element: <MUIAccordionPage /> },
                { path: 'alert', element: <MUIAlertPage /> },
                { path: 'autocomplete', element: <MUIAutocompletePage /> },
                { path: 'avatar', element: <MUIAvatarPage /> },
                { path: 'badge', element: <MUIBadgePage /> },
                { path: 'breadcrumbs', element: <MUIBreadcrumbsPage /> },
                { path: 'buttons', element: <MUIButtonsPage /> },
                { path: 'checkbox', element: <MUICheckboxPage /> },
                { path: 'chip', element: <MUIChipPage /> },
                { path: 'data-grid', element: <MUIDataGridPage /> },
                { path: 'dialog', element: <MUIDialogPage /> },
                { path: 'list', element: <MUIListPage /> },
                { path: 'menu', element: <MUIMenuPage /> },
                { path: 'pagination', element: <MUIPaginationPage /> },
                { path: 'pickers', element: <MUIPickersPage /> },
                { path: 'popover', element: <MUIPopoverPage /> },
                { path: 'progress', element: <MUIProgressPage /> },
                { path: 'radio-button', element: <MUIRadioButtonsPage /> },
                { path: 'rating', element: <MUIRatingPage /> },
                { path: 'slider', element: <MUISliderPage /> },
                { path: 'stepper', element: <MUIStepperPage /> },
                { path: 'switch', element: <MUISwitchPage /> },
                { path: 'table', element: <MUITablePage /> },
                { path: 'tabs', element: <MUITabsPage /> },
                { path: 'textfield', element: <MUITextFieldPage /> },
                { path: 'timeline', element: <MUITimelinePage /> },
                { path: 'tooltip', element: <MUITooltipPage /> },
                { path: 'transfer-list', element: <MUITransferListPage /> },
                { path: 'tree-view', element: <MUITreesViewPage /> },
              ],
            },
            {
              path: 'extra',
              children: [
                { element: <Navigate to="/components/extra/animate" replace />, index: true },
                { path: 'animate', element: <DemoAnimatePage /> },
                { path: 'carousel', element: <DemoCarouselsPage /> },
                { path: 'chart', element: <DemoChartsPage /> },
                { path: 'copy-to-clipboard', element: <DemoCopyToClipboardPage /> },
                { path: 'editor', element: <DemoEditorPage /> },
                { path: 'form-validation', element: <DemoFormValidationPage /> },
                { path: 'image', element: <DemoImagePage /> },
                { path: 'label', element: <DemoLabelPage /> },
                { path: 'lightbox', element: <DemoLightboxPage /> },
                { path: 'map', element: <DemoMapPage /> },
                { path: 'mega-menu', element: <DemoMegaMenuPage /> },
                { path: 'multi-language', element: <DemoMultiLanguagePage /> },
                { path: 'navigation-bar', element: <DemoNavigationBarPage /> },
                { path: 'parentOrganization-chart', element: <DemoOrganizationalChartPage /> },
                { path: 'scroll', element: <DemoScrollbarPage /> },
                { path: 'snackbar', element: <DemoSnackbarPage /> },
                { path: 'text-max-line', element: <DemoTextMaxLinePage /> },
                { path: 'upload', element: <DemoUploadPage /> },
                { path: 'markdown', element: <DemoMarkdownPage /> },
              ],
            },
          ],
        },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: 'pricing', element: <PricingPage /> },
        { path: 'payment', element: <PaymentPage /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },

    // Agent Tablet Routes
    {
      path: 'agent',
      children: [
        {
          element: (
            <AuthGuard>
              <AgentLayout />
            </AuthGuard>
          ),
          children: [
            { element: <AgentOrdersListPage />, index: true },
            { path: ':orderId', element: <AgentOrderDetailPage /> },
            // Voice Agent sub-routes
            {
              path: 'voice-queue',
              element: <VoiceAgentDashboardPage />,
            },
            {
              path: 'voice-queue/:id',
              element: <VoiceAgentOrderTakingPage />,
            },
          ],
        },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
